import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { firestore } from "../../../configs/FirebaseConfig";
import { COMPANY_COUNTRY_CODE } from "../../../constants/CompanyConstants";
import { FIRESTORE_CRATE_STOCK_LOGS_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../constants/FirestoreConstant";

// dateRange: [startUnix, endUnix] on createdAt.
export const useCratesStockLog = (dateRange) => {
  const [cratesLogs, setCratesLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [start, end] = dateRange;

  useEffect(() => {
    setIsLoading(true);

    const logsColRef = collection(
      firestore,
      FIRESTORE_REGIONS_TABLE,
      COMPANY_COUNTRY_CODE,
      FIRESTORE_CRATE_STOCK_LOGS_TABLE,
    );

    const q = query(
      logsColRef,
      where("createdAt", ">=", start),
      where("createdAt", "<=", end),
      orderBy("createdAt", "desc"),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const logs = [];
        snapshot.forEach((doc) => {
          logs.push({ id: doc.id, ...doc.data() });
        });
        setCratesLogs(logs);
        setIsLoading(false);
        setError(null);
      },
      (err) => {
        console.error("Error fetching crates logs:", err);
        setError(err.message);
        setCratesLogs([]);
        setIsLoading(false);
      },
    );

    return () => unsubscribe();
  }, [start, end]);

  return { cratesLogs, isLoading, error };
};
